import { MainScreenType } from 'constants/types'
import instance from './instance'

/**
 * =====================================================
 * 환경설정
 * 1. 메뉴 목록
 * 2. 공통코드
 * 3. 환경설정
 * 4. 에디터 이미지
 * 5. 게시판
 * 6. 첨부파일
 * 7. 대시보드
 * 8. 개인정보 변경
 * 101. 거래처 계정관리
 * 102. 검사결과
 * 103. 코로나 검사결과
 * 104. 검사항목조회
 * 105. 검사결과 연동
 * =====================================================
 */

// ---------------------- 메뉴 목록 시작 ------------------
/**
 * 메뉴 목록 호출
 * @returns
 */
export const apiGetCategoryList = async () => {
	return await instance.get('/front/menus').then((result) => result.data)
}

/**
 * 지점코드, 장치코드로 메인화면 찾기
 * @param request
 * @returns
 */
export const apiMainScreen = async (request: MainScreenType) => {
	return await instance
		.get('/front/mainScreen', { params: request })
		.then((result) => result.data)
}

/**
 * subsort 목록
 * @param request
 * @returns
 */
export const apiSubSortList = async () => {
	return await instance.get('/front/subSortList').then((result) => result.data)
}

// export const apiProductList = async (request: any) => {
// 	return await instance
// 		.get('/front/fileDestList', {
// 			params: {
// 				...request,
// 			},
// 		})
// 		.then((result) => result.data)
// }

/**
 * 제품 썸네일 목록
 * @param request
 * @returns
 */
export const apiThumbnailList = async (request: any) => {
	return await instance
		.get('/front/thumbnailList', {
			params: {
				...request,
			},
		})
		.then((result) => result.data)
}

// ---------------------- 메뉴 목록 끝 -------------------

/**
 * 제품의 상세 스팩, 이미지 등
 * @param request
 * @returns
 */
export const apiFileDestList = async (request: any) => {
	return await instance
		.get('/front/fileDestList', {
			params: {
				...request,
			},
		})
		.then((result) => result.data)
}

/**
 * 통계 전송
 * @param request
 * userId, kioskDeviceId, categoryId = deviceInfo에 있는 값
 * , productId, subsortId, subId (첨부파일 sub id)
 * request = {
 * 	userId: deviceInfo.userId,
 * 	kioskDeviceId: deviceInfo.kioskDeviceId,
 * 	categoryId: deviceInfo.categoryId,
 * 	productId: productId,
 * 	subsortId: subsortId,
 * 	subId: subId,
 * }
 */
export const apiSaveLog = async (request: any) => {
	return await instance.post('/front/saveLog', { ...request })
}

/**
 * 2025.07.05 메인 이미지 목록 (지점별에서 전체로 변경됨)
 * @returns
 */
export const apiMainImageList = async () => {
	return await instance.get('/front/mainImageList').then((result) => result.data)
}

export const apiSpsDefineList = async (request: any) => {
	return await instance
		.get('/front/spsDefineList', {
			params: {
				...request,
			},
		})
		.then((result) => result.data)
}
